import React from 'react';
import { Spin } from 'antd'; // Ant Design spinner component

const ProcessingMessage = () => {
    const styles = {
        processingContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '300px',
            marginTop: '50px',
            backgroundColor: '#f9f9f9',
            borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            padding: '20px',
            textAlign: 'center',
        },
        heading: {
            color: '#2196F3',
            marginTop: '20px',
            fontSize: '24px',
        },
        paragraph: {
            color: '#666',
            marginTop: '10px',
            fontSize: '16px',
        },
        button: {
            marginTop: '20px',
            padding: '10px 20px',
            fontSize: '16px',
            color: '#fff',
            backgroundColor: '#2196F3',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            textDecoration: 'none',
        },
    };

    return (
        <div style={styles.processingContainer}>
            <Spin size="large" />
            <h2 style={styles.heading}>Registration Successful!</h2>
            <p style={styles.paragraph}>
                You have successfully registered for the admission process. A representative will contact you soon with details about the first test, including the date and time.
            </p>
            <p style={styles.paragraph}>
                After completing the test, the admission form will be made available for you to complete your application.
            </p>
            <p style={styles.paragraph}>
                Please check your email regularly for updates. You can download your admit card by clicking the button below.
            </p>
            <a href="#admit-card" style={styles.button}>
                Download Admit Card
            </a>
        </div>
    );
};

export default ProcessingMessage;
